import React, { useCallback, useEffect, useRef, useState } from "react";
import { FocusSDK, isFocusEnv } from "@/utils";
import styles from "./index.module.less";
import IconFont from "@/components/icon";
import Bus from "@/utils/bus";
import i18n from "@/i18n";
import { handleLinkClick } from "@/components/chat/message/AINoticeCard/utils";
import { analysisLog } from "@/utils/logAnalytics";
export default function SysNoticeCard({
  params,
  closeCurWindow,
  winTimer
}: {
  params: any;
  closeCurWindow: Function;
  winTimer: number;
}) {
  const title = decodeURIComponent(params?.title || "");
  const fields = decodeURIComponent(params?.fields || "");
  const { deepLink } = params;
  const content = fields ? JSON.parse(fields) : [];
  const [isForceLogout, setIsForceLogout] = useState(false);
  const wtimer = useRef<any>(null);

  const closeNoticeCard = useCallback(() => {
    if (isFocusEnv()) {
      closeCurWindow?.();
    }
  }, [closeCurWindow]);

  const viewDetail = useCallback(() => {
    if (!isFocusEnv()) {
      return;
    }
    analysisLog("Xtbg_Announcement_ForcedPopup", "Details");
    if (!isForceLogout) {
      handleLinkClick(deepLink || "");
      FocusSDK.sendIpcMessage("showMainwindow");
    }
    // tj: 已被踢出后直接关闭
    closeNoticeCard();
  }, [isForceLogout, closeNoticeCard, deepLink]);

  const readHandle = useCallback(async () => {
    analysisLog("Xtbg_Announcement_ForcedPopup", "Close");
    closeNoticeCard();
  }, [closeNoticeCard]);

  // tj: 强制退出 (解决强制退出后点击提醒页面卡死)
  const forceQuitListener = useCallback(() => {
    setIsForceLogout(true);
  }, []);

  useEffect(() => {
    Bus.on("chat:force_quit", forceQuitListener);
    return () => {
      Bus.off("chat:force_quit", forceQuitListener);
    };
  }, [forceQuitListener]);

  // 定时关闭
  useEffect(() => {
    if (winTimer) {
      wtimer.current = setTimeout(() => {
        analysisLog("Xtbg_Announcement_ForcedPopup", "AutoClose");
        closeNoticeCard();
      }, winTimer * 60 * 1000);
    }
    return () => {
      wtimer.current && clearTimeout(wtimer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles["sys-notice-card"]}>
      {/* <div className={styles["snc-spliter"]} /> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flex: 1
        }}
      >
        <div style={{ flex: 1, padding: "8px 16px 0" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between"
            }}
          >
            <IconFont className={styles["scn-primary"]} style={{ fontSize: 20 }} type="iconlaba" />
            <p className={styles["calendar-title"]}>{title}</p>
            <IconFont className={styles["scn-close"]} type="iconty_close" onClick={readHandle} />
          </div>
          {!!content.length &&
            content.map((field: any, index: number) => {
              return (
                <p key={index} className={styles["snc-content"]}>
                  <label>{field.name}：</label>
                  {field.value}
                </p>
              );
            })}
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
          <p className={styles["snc-btn"]} onClick={viewDetail}>
            {i18n.t("common:viewDetail")}
          </p>
          <p className={styles["snc-btn-primary"]} onClick={readHandle}>
            {i18n.t("common:tagRead")}
          </p>
        </div>
      </div>
    </div>
  );
}
